
<template>
  <div>
    <div class="bg-white">
      <Nav></Nav>
    </div>
    <div class="body-content">
      <div class="content-wrapper">
        <side-nav></side-nav>
        <div class="main-content">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideNav from '@/components/document/SildeNav'
import Nav from '@/components/Nav'
export default {
  name: "Document",
  components: {
    SideNav,
    Nav
  },
  mounted: function () {
    // const is_developer = this.$store.getters.isDeveloper
    // if(!is_developer){
    //   this.$router.push("/404")
    // }
  }
}
</script>
<style scoped>
.div-document {
  height: 100%;
}
.clear-both {
  clear: both;
}
.body-content {
  padding: 0 10%;
  background: #f5f5fa;
  display: flex;
  flex-wrap: wrap;
  min-height: 90%;
}
.content-wrapper {
  background: #fff;
  margin-top: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.main-content {
  flex: 1;
  padding: 20px 30px;
  min-width: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/document/index.vue